export default __webpack_public_path__ + "static/media/slider2.2ff90180.jpg";